/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PodcastPlayer_podcast$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PodcastList_podcasts$ref: FragmentReference;
declare export opaque type PodcastList_podcasts$fragmentType: PodcastList_podcasts$ref;
export type PodcastList_podcasts = $ReadOnlyArray<{|
  +$fragmentRefs: PodcastPlayer_podcast$ref,
  +$refType: PodcastList_podcasts$ref,
|}>;
export type PodcastList_podcasts$data = PodcastList_podcasts;
export type PodcastList_podcasts$key = $ReadOnlyArray<{
  +$data?: PodcastList_podcasts$data,
  +$fragmentRefs: PodcastList_podcasts$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PodcastList_podcasts",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PodcastPlayer_podcast"
    }
  ],
  "type": "PodcastType",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'ebf048a7108367b67eb2bddca3f85f7b';

module.exports = node;
